import { createTheme } from "@mui/material";

// テーマの型拡張
declare module "@mui/material/styles" {
  interface PaletteColor {
    "50"?: string;
    "100"?: string;
    "200"?: string;
    "300"?: string;
    "400"?: string;
    "500"?: string;
    "600"?: string;
    "700"?: string;
    "800"?: string;
    "900"?: string;
  }
  interface Palette {
    caution: Palette["primary"]; // cautionプロパティを追加し、型はprimaryと同じにする
  }
  interface PaletteOptions {
    caution?: PaletteOptions["primary"]; // cautionのオプションを追加
  }
}

export const customTheme = createTheme({
  palette: {
    primary: {
      main: "#52A48B",
      contrastText: "#fff",
      50: "#F0FAF7",
      100: "#E1F5EF",
      200: "#CAE8DF",
      300: "#92D1C0",
      400: "#52A48B",
      500: "#3C8F76",
      600: "#2B7A63",
      700: "#206B55",
      800: "#1E5746",
      900: "#1C4237",
    },
    grey: {
      50: "#F9FAF9",
      100: "#F2F3F3",
      200: "#E4E5E5", //修正前：#EAECEC
      300: "#D0D4D3",
      400: "#98A19E",
      500: "#66736F",
      600: "#475652",
      700: "#344540",
      800: "#1D302A",
      900: "#10241E",
    },
    caution: {
      main: "#EA4E3B",
      50: "#FEF3F2",
      100: "#FEE5E2",
      200: "#FED0CA",
      300: "#FDA69B",
      400: "#F97766",
      500: "#EA4E3B",
      600: "#D93620",
      700: "#B42A18",
      800: "#912618",
      900: "#7A251A",
    },
  },
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          "&:focus": {
            outline: "1px solid #52A48B",
          },
        },
      },
    },
  },
});
